<template>
    <div v-if="ay_list!=null">
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-card class="box">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Copy Component Details</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <br />
            <v-row dense>
                <v-col cols="12" sm="5" md="5" style="text-align: right;">
                    <v-combobox rounded dense required return-object v-model="from_ay" :items="ay_list" item-text="ay"
                        label="From Academic Year" outlined @change="getDetails()" />
                </v-col>
                <v-col cols="12" sm="2" md="2" style="text-align: center;">
                    <v-btn text color="#0f2027" :loading="copy_btn_load">
                        <v-icon large color="#0f2027">mdi-arrow-right-bold-circle</v-icon>
                    </v-btn>
                </v-col>
                <v-col cols="12" sm="5" md="5" style="text-align: left;">
                    <v-combobox rounded dense required v-model="to_ay" return-object :items="ay_list" item-text="ay"
                        label="To Academic Year" outlined />
                </v-col>
            </v-row>
            <v-row dense justify="center">
                <v-btn v-if="to_ay" class="button" :loading="loader" @click="copyCompDetails()">Copy Component
                    Details</v-btn>
            </v-row>
            <v-col cols="12" sm="12" md="12" v-if="fees_component_list!=''">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Component Details</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <br />
                <v-data-table :headers="headers_comp" :items="fees_component_list" dense sort-by=""
                    class="elevation-1 mytable" :search="search"> </v-data-table>
            </v-col>
            <v-col cols="12" sm="12" md="12" v-if="fees_installment_list!=''">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Installment Details</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <br />
                <v-data-table :headers="headers_inst" :items="fees_installment_list" dense sort-by=""
                    class="elevation-1 mytable" :search="search"> </v-data-table>
            </v-col>
            <v-col cols="12" md="12" sm="12" v-if="fees_config!=''">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Fees Installment Matrix Details</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <br />
                <v-data-table :headers="headers_config" :items="fees_config" dense sort-by=""
                    class="elevation-1 mytable" :search="search"> </v-data-table>
            </v-col>
        </v-card>
    </div>
</template>
<script>
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
    import axios from "axios";
export default {
    components: {
        Breadcrumbs,
    },
        data: () => ({
            ay_list: null,
            to_ay: null,
            from_ay: null,
            from_slot_list: null,
            // extraBreadcrumbItems: [


            // ],
            // breadcrumbClass: "breadcrumb-style1",
            to_slot_list: null,
            search: "",
            copy_btn_load: false,
            standard_list: [],
            singleSelect: false,
            selectedTasks: [],
            standard: null,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            loader:false,
            fees_config: [],
            fees_installment_list: [],
            fees_component_list: [],
            headers_comp: [
                { text: "Sr. No.", value: "srno" },
                { text: "Component", value: "name" },
            ],
            headers_inst: [
                { text: "Sr. No.", value: "srno" },
                { text: "Installment", value: "name" },
            ],
            headers_config: [
                { text: "Sr. No.", value: "srno" },
                { text: "Academic Year", value: "academicyear" },
                { text: "Component", value: "feescomponentacademicyear" },
                { text: "Installment", value: "feesinstallmentacademicyear" },
            ],
        }),

        methods: {
            copyCompDetails(){
                const data = {
                    ay: this.from_ay.id,
                    to_ay: this.to_ay.id
                };
                this.loader = true
                axios
                    .post("/AccountingAndFees/copyCompDetails", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4CAF50", "Copied Successfully...");
                            this.loader = false
                            this.onLoad()
                        } else if (res.data.flag == "NO") {
                            this.loader = false
                            this.showSnackbar("#b71c1c", res.data.smsg);
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            this.loader = false
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {
                        this.to_ay = null
                        this.from_ay = null
                        this.fees_config = []
                        this.fees_installment_list = []
                        this.fees_component_list = []
                    });
            },
            getDetails() {
                const data = {
                    ay: this.from_ay.id,
                };
                axios
                    .post("/AccountingAndFees/getComponetDetails", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.fees_config = res.data.fees_config;
                            this.fees_installment_list = res.data.fees_installment_list;
                            this.fees_component_list = res.data.fees_component_list;
                        } else if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.smsg);
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
            onLoad() {
                axios
                    .post("/Examination/getInitialData")
                    .then((res) => {
                        this.ay_list = res.data.ay_list;
                        this.standard_list = res.data.standard_list;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {
                        this.copy_offer_btn_load = false;
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
        mounted() {
            this.onLoad();
        },
    };
</script>
<style scoped>
    .mytable /deep/ thead th {
        background: #2980b9;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
</style>
